module.exports = __webpack_public_path__ + "static/img/fankui.ddfe512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fankui.jpg
// module id = PeYW
// module chunks = 46